// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/aircraft-parking.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/aircraft-parking/aircraft-parking.js';

mount([g0]);
